goog.provide("shadow.js.shim.module$$mui$system$Stack$default");
shadow.js.shim.module$$mui$system$Stack$default = shadow.js.shim.module$$mui$system$Stack.default;
